import React, { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import type { AdminPulseVisibility } from '@/lib/admin-pulse-filter';

interface AdminPulseVisibilityContextValue {
  adminPulseVisibility: AdminPulseVisibility;
  setAdminPulseVisibility: (v: AdminPulseVisibility) => void;
  cycleAdminPulseVisibility: () => void;
}

const AdminPulseVisibilityContext = createContext<AdminPulseVisibilityContextValue | undefined>(undefined);

export function AdminPulseVisibilityProvider({ children }: { children: ReactNode }) {
  const [adminPulseVisibility, setAdminPulseVisibility] = useState<AdminPulseVisibility>('hidden');

  const cycleAdminPulseVisibility = useCallback(() => {
    setAdminPulseVisibility((prev) =>
      prev === 'hidden' ? 'level_1' : prev === 'level_1' ? 'all' : 'hidden'
    );
  }, []);

  return (
    <AdminPulseVisibilityContext.Provider
      value={{ adminPulseVisibility, setAdminPulseVisibility, cycleAdminPulseVisibility }}
    >
      {children}
    </AdminPulseVisibilityContext.Provider>
  );
}

export function useAdminPulseVisibility() {
  const ctx = useContext(AdminPulseVisibilityContext);
  if (!ctx) {
    throw new Error('useAdminPulseVisibility must be used within AdminPulseVisibilityProvider');
  }
  return ctx;
}
